import { defineStore, storeToRefs } from 'pinia'
import { useModalStore } from '~/stores'

export const useShowErrorStore = defineStore('showErrorStore', () => {
    const useModalStoreInstance = useModalStore()
    const modalData = ref({
        modalName: '',
        message: '',
        title: '',
        icon: '',
        cancelButton: '',
        confirmButton: '',
        type: 'error',
        onClose: null,
        onCancel: null,
        onConfirm: null,
    })
    const { showErrorModal } = storeToRefs(useModalStoreInstance)

    const onShowErrorModal = (data) => {
        modalData.value.modalName = data.modalName
        modalData.value.message = data.message
        modalData.value.title = data.title
        modalData.value.icon = data.icon
        modalData.value.error = data.error
        modalData.value.type = data.type
        modalData.value.cancelButton = data.cancelButton
        modalData.value.confirmButton = data.confirmButton
        modalData.value.onClose = data.onClose
        modalData.value.onCancel = data.onCancel
        modalData.value.onConfirm = data.onConfirm

        showErrorModal.value = true
    }

    const countActions = computed(() => {
        let count = 0
        if (modalData.value.onClose) {
            count++
        }
        if (modalData.value.onCancel) {
            count++
        }
        if (modalData.value.onConfirm) {
            count++
        }
        return count
    })

    const closeAction = () => {
        showErrorModal.value = false
        if (
            modalData.value.onClose &&
            typeof modalData.value.onClose === 'function'
        ) {
            modalData.value.onClose()
        }
    }
    const confirmAction = () => {
        showErrorModal.value = false

        if (
            modalData.value.onConfirm &&
            typeof modalData.value.onConfirm === 'function'
        ) {
            modalData.value.onConfirm()
        }
    }
    const cancelAction = () => {
        showErrorModal.value = false

        if (
            modalData.value.onCancel &&
            typeof modalData.value.onCancel === 'function'
        ) {
            modalData.value.onCancel()
        }
    }

    return {
        modalData,
        cancelAction,
        confirmAction,
        closeAction,
        onShowErrorModal,
        countActions,
    }
})
